<template>
  <div>
    <PageAllow controller="AccountAds" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color" v-show="!currentItemMode">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherKeyword
                v-model="options.top_title"
                @text="KeyWord = $event"
                :label="$t('AccountAds.select')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                small
                color="primary"
                class="ms-1"
                @click.stop="currentItemMode = 'new'"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("AccountAds.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="account_ads"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>

          <template v-slot:item.top_sort="{ item,index}">
            <span
              :v-resize="!index ? $stickTableResizer() : null"
            >
            </span>
            {{ item.top_sort ? $t("AccountAds.top") : "-" }}
          </template>

          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('AccountAds', 'view')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentItemMode = 'view';
                    currentItem = item;
                  "
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("AccountAds.actions.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("AccountAds.actions.detail") }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  :href="'/#/account-ads/push-to-shop/' + item.id"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("AccountAds.actions.customer") }}
                </v-btn>
              </template>
              <span>{{ $t("AccountAds.actions.customer") }}</span>
            </v-tooltip>

            <v-tooltip
              top
              v-if="$permission.permissionAllow('AccountAds', 'edit')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentItemMode = 'edit';
                    currentItem = item;
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("AccountAds.actions.edit") }}
                </v-btn>
              </template>
              <span>{{ $t("AccountAds.actions.edit") }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    delDialog = true;
                    delId = item.id;
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("AccountAds.actions.delete") }}
                </v-btn>
              </template>
              <span>{{ $t("AccountAds.actions.delete") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <v-dialog v-model="delDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="delDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("AccountAds.del_text") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="delDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="Del()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AccountAdsDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getAccountAdsFromAPI()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import AccountAds from "@/api/account_ads";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import AccountAdsDetail from "./plugins/Detail";

const defaultOptions = {
  top_title: "",
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("ads-options")
        ? sessionStorage.getItem("ads-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    currentItemMode: null,
    account_ads: [],
    currentItem: null,
    delDialog: false,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    AccountAdsDetail,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.customerMaintenance"),
        disabled: false,
        href: "/qacenter",
      },
      {
        text: i18n.t("Nav.accountAds"),
        disabled: true,
        href: "/account-ads",
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("AccountAds.Fields.title"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "top_title",
        },
        {
          text: i18n.t("AccountAds.Fields.status"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "pub_flg_str",
        },
        {
          text: i18n.t("AccountAds.Fields.top"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "top_sort",
        },
        {
          text: i18n.t("AccountAds.Fields.created"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "created",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "actions",
        },
      ];
    },
    ...mapState(["loading","stickTableCols"]),
  },

  mounted() {
    this.getAccountAdsFromAPI();
  },

  methods: {
    onSearch() {
      this.options = Object.assign({},this.options, {
        top_title: this.KeyWord,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getAccountAdsFromAPI() {
      AccountAds.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.account_ads = response.data.account_ads;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },

    Del() {
      AccountAds.del(this.delId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getAccountAdsFromAPI();
          }
          this.delDialog = false;
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getAccountAdsFromAPI();
        sessionStorage.setItem("ads-options", JSON.stringify(this.options));
      },
    },

    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
  },
};
</script>

<style>
</style>